<template>
    <div class="rounded border bg-white">
        <div class="flex justify-between px-2 py-3 handle">
            <div class="flex items-center space-x-3 truncate">
                <button type="button" class="cursor-move focus:outline-none">
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
                    </svg>
                </button>

                <div
                    class="flex items-center space-x-3 -my-4 h-12 cursor-pointer"
                    @click.native="data.type !== 'dashboardRecentActivity' ? $emit('toggle', data) : ''"
                >
                    <svg v-if="data.type === 'dashboardContentBlock'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><polyline fill="none" points="14 2 14 8 20 8" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="13" y2="13"/><line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="17" y2="17"/><polyline fill="none" points="10 9 9 9 8 9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                    <svg v-else-if="data.type === 'dashboardTextBlock'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M5.2498 3C4.00727 3 3 4.00727 3 5.2498V18.7486C3 19.9911 4.00727 20.9984 5.2498 20.9984H11.1644L11.5202 19.5754C11.5266 19.5497 11.5333 19.5241 11.5402 19.4985H5.2498C4.83563 19.4985 4.49987 19.1628 4.49987 18.7486V5.2498C4.49987 4.83563 4.83563 4.49987 5.2498 4.49987H18.7486C19.1628 4.49987 19.4985 4.83563 19.4985 5.2498V11.2317C19.9774 11.0412 20.492 10.9678 20.9984 11.0115V5.2498C20.9984 4.00727 19.9911 3 18.7486 3H5.2498ZM15.3539 14.9989H11.2493C10.835 14.9989 10.4993 15.3347 10.4993 15.7489C10.4993 16.163 10.835 16.4988 11.2493 16.4988H13.8541L15.3539 14.9989ZM8.74949 8.24954C8.74949 8.80177 8.30181 9.24945 7.74958 9.24945C7.19735 9.24945 6.74967 8.80177 6.74967 8.24954C6.74967 7.69731 7.19735 7.24963 7.74958 7.24963C8.30181 7.24963 8.74949 7.69731 8.74949 8.24954ZM11.2493 7.4996C10.8351 7.4996 10.4993 7.83536 10.4993 8.24954C10.4993 8.66371 10.8351 8.99947 11.2493 8.99947H16.7488C17.163 8.99947 17.4987 8.66371 17.4987 8.24954C17.4987 7.83536 17.163 7.4996 16.7488 7.4996H11.2493ZM11.2493 11.2493C10.835 11.2493 10.4993 11.585 10.4993 11.9992C10.4993 12.4134 10.835 12.7491 11.2493 12.7491H16.7486C17.1629 12.7491 17.4985 12.4134 17.4985 11.9992C17.4985 11.585 17.1629 11.2493 16.7486 11.2493H11.2493ZM7.74958 12.9991C8.30181 12.9991 8.74949 12.5515 8.74949 11.9992C8.74949 11.447 8.30181 10.9993 7.74958 10.9993C7.19735 10.9993 6.74967 11.447 6.74967 11.9992C6.74967 12.5515 7.19735 12.9991 7.74958 12.9991ZM8.74949 15.7489C8.74949 16.3011 8.30181 16.7488 7.74958 16.7488C7.19735 16.7488 6.74967 16.3011 6.74967 15.7489C6.74967 15.1966 7.19735 14.749 7.74958 14.749C8.30181 14.749 8.74949 15.1966 8.74949 15.7489ZM19.0984 12.6686L13.1965 18.5705C12.8524 18.9146 12.6083 19.3458 12.4903 19.8179L12.0327 21.6484C11.8336 22.4445 12.5547 23.1656 13.3508 22.9666L15.1813 22.5089C15.6534 22.3909 16.0846 22.1468 16.4287 21.8027L22.3306 15.9008C23.2231 15.0082 23.2231 13.5611 22.3306 12.6686C21.4381 11.7761 19.991 11.7761 19.0984 12.6686Z" fill="#212121"/></svg>
                    <svg v-else-if="data.type === 'dashboardLinks'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"/></svg>
                    <svg v-else-if="data.type === 'dashboardRecentActivity'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M19 7h5v2h-5V7zm-2 5h7v2h-7v-2zm3 5h4v2h-4v-2zM2 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H2zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/></svg>
                    <svg v-else-if="data.type === 'dashboardCommissionStructure'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                    <svg v-else-if="data.type === 'dashboardEarningsCalculator'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-3.5-6H14a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1V6h2v2h2.5v2H10a.5.5 0 1 0 0 1h4a2.5 2.5 0 1 1 0 5h-1v2h-2v-2H8.5v-2z"/></svg>
                    <svg v-else-if="data.type === 'dashboardEmbed'" class="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>
                    <svg v-else-if="data.type === 'dashboardAccordion'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/></svg>
                    <svg v-else-if="data.type === 'dashboardCustomBlock'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M22 9.999V20a1 1 0 0 1-1 1h-8V9.999h9zm-11 0V21H3a1 1 0 0 1-1-1V9.999h9zM11 3v4.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v3.999h-9V3h8z"/></svg>
                    <svg v-else-if="data.type === 'dashboardProgramOverview'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993zM4 5v14h16V5H4zm2 2h6v6H6V7zm2 2v2h2V9H8zm-2 6h12v2H6v-2zm8-8h4v2h-4V7zm0 4h4v2h-4v-2z"/></svg>
                    <svg v-else class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path d="M13 6v15h-2V6H5V4h14v2z"></path></svg>

                    <span class="text-sm text-gray-900 truncate max-w-96">
                        {{ data.title }}
                        <span v-if="!data.title" class="text-gray-500">
                            <template v-if="data.type === 'dashboardRecentActivity'">Recent activity</template>
                            <template v-if="data.type === 'dashboardCustomBlock'">Universal section</template>
                            <template v-if="data.type === 'dashboardContentBlock'">Content section</template>
                            <template v-if="data.type === 'dashboardTextBlock'">Text</template>
                            <template v-if="data.type === 'dashboardLinks'">Links</template>
                            <template v-if="data.type === 'dashboardAccordion'">Accordion / FAQ</template>
                            <template v-if="data.type === 'dashboardCommissionStructure'">Commission structure</template>
                            <template v-if="data.type === 'dashboardEarningsCalculator'">Earnings calculator</template>
                            <template v-if="data.type === 'dashboardEmbed'">Embed code</template>
                            <template v-if="data.type === 'dashboardProgramOverview'">Program overview</template>
                        </span>
                    </span>

                </div>
            </div>
            <!-- Delete/edit buttons -->
            <div class="flex space-x-2">
                <button type="button" class="focus:outline-none" @click.native="$emit('remove', data)"
                        v-if="!data.protected">
                    <svg class="w-5 h-5 text-gray-500 hover:text-red-600" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"/>
                    </svg>
                </button>
                <button
                    v-if="data.type !== 'dashboardRecentActivity'"
                    type="button"
                    class="focus:outline-none"
                    @click.native="$emit('toggle', data)"
                >
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900"
                         v-bind:class="{ 'text-teal-600 hover:text-teal-700': data.edit }"
                         fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 24 24"
                         width="24"
                         height="24"
                    >
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M3.34 17a10.018 10.018 0 0 1-.978-2.326 3 3 0 0 0 .002-5.347A9.99 9.99 0 0 1 4.865 4.99a3 3 0 0 0 4.631-2.674 9.99 9.99 0 0 1 5.007.002 3 3 0 0 0 4.632 2.672c.579.59 1.093 1.261 1.525 2.01.433.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 9.99 9.99 0 0 1-2.501 4.337 3 3 0 0 0-4.631 2.674 9.99 9.99 0 0 1-5.007-.002 3 3 0 0 0-4.632-2.672A10.018 10.018 0 0 1 3.34 17zm5.66.196a4.993 4.993 0 0 1 2.25 2.77c.499.047 1 .048 1.499.001A4.993 4.993 0 0 1 15 17.197a4.993 4.993 0 0 1 3.525-.565c.29-.408.54-.843.748-1.298A4.993 4.993 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8.126 8.126 0 0 0-.75-1.298A4.993 4.993 0 0 1 15 6.804a4.993 4.993 0 0 1-2.25-2.77c-.499-.047-1-.048-1.499-.001A4.993 4.993 0 0 1 9 6.803a4.993 4.993 0 0 1-3.525.565 7.99 7.99 0 0 0-.748 1.298A4.993 4.993 0 0 1 6 12c0 1.26-.47 2.437-1.273 3.334a8.126 8.126 0 0 0 .75 1.298A4.993 4.993 0 0 1 9 17.196zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                    </svg>
                </button>
            </div>
            <!-- ./ Delete/edit buttons -->
        </div>

        <div v-if="data.edit && data.type !== 'dashboardRecentActivity'" class="p-4 bg-gray-50 bg-opacity-75 border-t space-y-4">
            <div v-if="data.type === 'dashboardEmbed'">
                <Embed :data="data" :show-section-toggle="true"></Embed>
            </div>
            <div v-else-if="data.type === 'dashboardAccordion'" class="space-y-4">
                <text-field
                    label="Title"
                    name="option1"
                    v-model="data.title"
                >
                </text-field>

                <text-editor
                    label="Description"
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                >
                </text-editor>

                <div>
                    <label class="flex justify-between items-center mb-1.5 text-sm"> Content </label>
                    <Accordion :data="data" :unique_id="unique_id"></Accordion>
                </div>
            </div>
            <div v-else-if="data.type === 'dashboardCustomBlock'" class="space-y-4">
                <text-field
                    label="Title"
                    name="option1"
                    v-model="data.title"
                >
                </text-field>

                <text-editor
                    label="Description"
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                >
                </text-editor>

                <div>
                    <label class="flex justify-between items-center mb-1.5 text-sm"> Content </label>
                    <CustomBlock :data="data" :options="options" :unique_id="unique_id"></CustomBlock>
                </div>
            </div>
            <div v-else-if="data.type === 'dashboardProgramOverview'" class="space-y-4">
                <text-field
                    label="Title"
                    name="option1"
                    v-model="data.title"
                >
                </text-field>

                <text-editor
                    label="Description"
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                >
                </text-editor>

                <div class="space-y-2">
                    <text-field label="Product overview title" v-model="data.product_description_title" placeholder="Product overview" />
                    <div class="flex items-center gap-1 overflow-x-auto">
                        <button
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="!data.product_description_icon || data.product_description_icon === 'none' ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            title="None"
                            @click="data.product_description_icon = 'none'"
                        >
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                        </button>
                        <button
                            v-for="ic in sectionIcons"
                            :key="ic.id"
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="data.product_description_icon === ic.id ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            :title="ic.label"
                            @click="data.product_description_icon = ic.id"
                            v-html="ic.svg"
                        ></button>
                    </div>
                    <text-editor
                        label="Content"
                        :text="data.product_description"
                        @input="(newValue) => { data.product_description = newValue }"
                    >
                    </text-editor>
                </div>

                <div class="space-y-2">
                    <text-field label="Who it's for title" v-model="data.ideal_customer_title" placeholder="Who it's for" />
                    <div class="flex items-center gap-1 overflow-x-auto">
                        <button
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="!data.ideal_customer_icon || data.ideal_customer_icon === 'none' ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            title="None"
                            @click="data.ideal_customer_icon = 'none'"
                        >
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                        </button>
                        <button
                            v-for="ic in sectionIcons"
                            :key="ic.id"
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="data.ideal_customer_icon === ic.id ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            :title="ic.label"
                            @click="data.ideal_customer_icon = ic.id"
                            v-html="ic.svg"
                        ></button>
                    </div>
                    <text-editor
                        label="Content"
                        :text="data.ideal_customer"
                        @input="(newValue) => { data.ideal_customer = newValue }"
                    >
                    </text-editor>
                </div>

                <div class="space-y-2">
                    <text-field label="Why promote us title" v-model="data.selling_points_title" placeholder="Why promote us" />
                    <div class="flex items-center gap-1 overflow-x-auto">
                        <button
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="!data.selling_points_icon || data.selling_points_icon === 'none' ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            title="None"
                            @click="data.selling_points_icon = 'none'"
                        >
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                        </button>
                        <button
                            v-for="ic in sectionIcons"
                            :key="ic.id"
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="data.selling_points_icon === ic.id ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            :title="ic.label"
                            @click="data.selling_points_icon = ic.id"
                            v-html="ic.svg"
                        ></button>
                    </div>
                    <text-editor
                        label="Content"
                        :text="data.selling_points"
                        @input="(newValue) => { data.selling_points = newValue }"
                    >
                    </text-editor>
                </div>

                <div class="space-y-2">
                    <text-field label="Program guidelines title" v-model="data.rules_title" placeholder="Program guidelines" />
                    <div class="flex items-center gap-1 overflow-x-auto">
                        <button
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="!data.rules_icon || data.rules_icon === 'none' ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            title="None"
                            @click="data.rules_icon = 'none'"
                        >
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                        </button>
                        <button
                            v-for="ic in sectionIcons"
                            :key="ic.id"
                            type="button"
                            class="p-1.5 rounded border transition-colors flex-shrink-0"
                            :class="data.rules_icon === ic.id ? 'border-gray-900 bg-gray-50' : 'border-transparent hover:border-gray-300'"
                            :title="ic.label"
                            @click="data.rules_icon = ic.id"
                            v-html="ic.svg"
                        ></button>
                    </div>
                    <text-editor
                        label="Content"
                        :text="data.rules"
                        @input="(newValue) => { data.rules = newValue }"
                    >
                    </text-editor>
                </div>

                <div class="space-y-3">
                    <toggle
                        v-model="data.show_commission_summary"
                        size="medium"
                        title="Show commission summary"
                    >
                        <template #description>Display the commission structure from program settings</template>
                    </toggle>
                    <toggle
                        v-model="data.show_cookie_duration"
                        size="medium"
                        title="Show cookie duration"
                    >
                        <template #description>Display the referral cookie lifetime</template>
                    </toggle>
                    <toggle
                        v-model="data.show_payout_info"
                        size="medium"
                        title="Show payout info"
                    >
                        <template #description>Display payout schedule and available methods</template>
                    </toggle>
                    <toggle
                        v-model="data.show_additional_tiers"
                        size="medium"
                        title="Show additional tiers"
                    >
                        <template #description>Display tiers, bonuses, product and goal commissions when available</template>
                    </toggle>
                    <toggle
                        v-model="data.show_resources_button"
                        size="medium"
                        title="Show Resources button"
                    >
                        <template #description>Display a button linking to the Resources page in the header</template>
                    </toggle>
                </div>
            </div>
            <div v-else class="space-y-4">

                <text-field
                    label="Title"
                    name="option1"
                    v-model="data.title"
                >
                </text-field>

                <text-editor
                    label="Description"
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                    >
                </text-editor>

                <div v-if="data.type === 'dashboardCommissionStructure'">
                    <toggle
                        v-model="data.show_tag_based_tiers"
                        size="medium"
                        title="Show partner & customer specific tiers"
                    >
                        <template #description>Display commissions based on partner or customer tags</template>
                    </toggle>
                </div>

                <div v-if="data.type !== 'dashboardCommissionStructure' && data.type !== 'dashboardEarningsCalculator'">
                    <label class="flex justify-between items-center mb-1.5 text-sm"> Content </label>

                    <div v-if="data.type === 'dashboardContentBlock'">
                        <ContentBlock :data="data" :options="options" :unique_id="unique_id"></ContentBlock>
                    </div>

                    <div v-if="data.type === 'dashboardTextBlock'">
                        <TextBlock :data="data" :options="options" :unique_id="unique_id"></TextBlock>
                    </div>

                    <div v-if="data.type === 'dashboardLinks'">
                        <Links :data="data" :options="options" :unique_id="unique_id"></Links>
                    </div>
                </div>

                <div v-if="data.type === 'dashboardEarningsCalculator'">
                    <EarningsCalculator :data="data" :options="options" :unique_id="unique_id"></EarningsCalculator>
                </div>

            </div>

            <!-- Visibility settings - shown for all resource types -->
            <div v-if="options.available_partner_tags && options.available_partner_tags.length > 0" class="flex justify-between items-start">
                <toggle
                    size="medium"
                    @update:model-value="data.visibility = $event ? 'tags' : 'all'"
                    :model-value="data.visibility === 'tags'"
                >
                </toggle>
                <span class="flex flex-col flex-grow">
                    <span class="text-sm font-medium">Limit visibility by partner tags</span>
                    <span class="text-sm text-gray-500">Only show this resource to partners with specific tags.</span>
                    <div v-if="data.visibility === 'tags'" class="flex flex-wrap gap-1.5 mt-2.5">
                        <button
                            v-for="tag in options.available_partner_tags"
                            :key="tag.key"
                            type="button"
                            @click="toggleVisibilityTag(tag.key)"
                            class="inline-flex items-center gap-1 text-xs font-medium rounded-full px-2.5 py-1 transition-colors focus:outline-none"
                            :class="isVisibilityTagSelected(tag.key)
                                ? 'bg-teal-500 hover:bg-teal-600 text-white'
                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'"
                        >
                            <svg v-if="isVisibilityTagSelected(tag.key)" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span>{{ tag.value }}</span>
                        </button>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {BubbleMenu, FloatingMenu,} from '@tiptap/vue-3'
import ContentBlock from "./Res/ContentBlock";
import TextBlock from "./Res/TextBlock";
import Links from "../../../resources/Res/Links";
import TextEditor from "../../../../../elements/TextEditor";
import EarningsCalculator from "./Res/EarningsCalculator";
import Embed from "../../../resources-builder/resources/Embed.vue";
import Accordion from "../../../resources/Res/Accordion.vue";
import CustomBlock from "./Res/CustomBlock.vue";

const sectionAvailableIcons = [
    { id: 'user-plus', label: 'Join', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>' },
    { id: 'share', label: 'Share', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>' },
    { id: 'dollar', label: 'Earn', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>' },
    { id: 'gift', label: 'Gift', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>' },
    { id: 'star', label: 'Star', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>' },
    { id: 'check-circle', label: 'Complete', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' },
    { id: 'megaphone', label: 'Announce', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>' },
    { id: 'trending-up', label: 'Growth', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>' },
    { id: 'mail', label: 'Email', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' },
    { id: 'rocket', label: 'Launch', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>' },
    { id: 'heart', label: 'Love', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' },
    { id: 'link', label: 'Link', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>' },
    { id: 'users', label: 'Users', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>' },
    { id: 'target', label: 'Target', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>' },
    { id: 'shield', label: 'Shield', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' },
    { id: 'book', label: 'Book', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>' },
    { id: 'box', label: 'Product', svg: '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>' },
];

export default {
    props: ['data', 'options', 'unique_id'],
    emits: ['remove', 'toggle'],
    components: {
        TextEditor,
        TextBlock,
        ContentBlock,
        Links,
        BubbleMenu,
        FloatingMenu,
        EarningsCalculator,
        Embed,
        Accordion,
        CustomBlock,
    },
    data() {
        return {
            sectionIcons: sectionAvailableIcons,
        }
    },
    methods: {
        toggleVisibilityTag(tagKey) {
            if (!this.data.visibility_tags) {
                this.data.visibility_tags = [];
            }
            const index = this.data.visibility_tags.indexOf(tagKey);
            if (index === -1) {
                this.data.visibility_tags.push(tagKey);
            } else {
                this.data.visibility_tags.splice(index, 1);
            }
        },
        isVisibilityTagSelected(tagKey) {
            return (this.data.visibility_tags || []).includes(tagKey);
        },
    },
    created() {
        this.data.unique_id = this.unique_id;
        if (!this.data.visibility) {
            this.data.visibility = 'all';
        }
        if (!this.data.visibility_tags) {
            this.data.visibility_tags = [];
        }
        if (this.data.type === 'dashboardProgramOverview') {
            if (!this.data.product_description_title) this.data.product_description_title = 'Product overview';
            if (!this.data.ideal_customer_title) this.data.ideal_customer_title = "Who it's for";
            if (!this.data.selling_points_title) this.data.selling_points_title = 'Why promote us';
            if (!this.data.rules_title) this.data.rules_title = 'Program guidelines';
            if (!this.data.product_description_icon) this.data.product_description_icon = 'box';
            if (!this.data.ideal_customer_icon) this.data.ideal_customer_icon = 'users';
            if (!this.data.selling_points_icon) this.data.selling_points_icon = 'trending-up';
            if (!this.data.rules_icon) this.data.rules_icon = 'shield';
        }
    }
}
</script>

<style lang="scss">
.ProseMirror {
    min-height: 70px;

    > * + * {
        margin-top: 0.75em;
    }

    ul,
    ol {
        padding: 0 1rem;
    }

    blockquote {
        padding-left: 1rem;
        border-left: 2px solid rgba(#0D0D0D, 0.1);
    }

    &:focus, &:active {
        outline: none;
    }

    h1 {
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    h2 {
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
}

.tiptap-menu {
    display: flex;

    button {
        border: none;
        background: none;
        color: #FFF;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.4rem;
        opacity: 0.6;

        &:focus, &:active {
            outline: none;
        }

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}

.floating-menu {
    display: flex;
    background-color: #111827;
    padding: 0.2rem;
    border-radius: 0.5rem;

    button {
        border: none;
        background: none;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.2rem;
        opacity: 0.6;

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}
</style>
